import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import ImportReviewPage from "../pages/ImportReviewPage";

const api = process.env.REACT_APP_BACKEND_URL;

export default function ProtectedImportReview() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  useEffect(() => {
    axios
      .get(`${api}/api/auth/me`, { withCredentials: true })
      .then((response) => {
        if (response.data.is_site_admin !== true) throw new Error("denied");
        return axios.get(
          `${api}/api/site-admin/catalog-review/migration-status`,
          { withCredentials: true },
        );
      })
      .then(() => axios.get(`${api}/api/auth/me`, { withCredentials: true }))
      .then((response) => setUser(response.data))
      .catch(() => navigate("/dashboard", { replace: true }));
  }, [navigate]);
  if (!user)
    return (
      <main className="auth-check" data-testid="import-review-auth-check" />
    );
  const logout = async () => {
    await axios.post(`${api}/api/auth/logout`, {}, { withCredentials: true });
    navigate("/login", { replace: true });
  };
  return <ImportReviewPage user={user} onLogout={logout} />;
}
